import styled from 'styled-components';

const HomeHeroThumbnail = styled.div`
  width: 100%;
  padding-bottom: 57%;
  background-size: cover;
  ${(props) => props.background && `background-image: url("${props.background}")`}
`;

const HomeHeroThumbnailSlide = (props) => {
  const { item } = props;

  return <HomeHeroThumbnail background={item.slideThumbnail}></HomeHeroThumbnail>;
};

export default HomeHeroThumbnailSlide;
